import {Directive, Module} from 'app/decorators';

@Module({
    name: "app.directives.fake-scroll",
})
@Directive('html', function($document, $uibPosition){
    "ngInject";
    return {
        restrict: 'E',
        link: function ($scope, $element) {
            let watcher = $scope.$watch(
                function() { return $element.find('body')[0].className; },
                function(classes){
                    let elems = [...$element.querySelectorAll('[fake-scroll]')];
                    let width = '0';
                    if (classes.includes('modal-open')) {
                        width = $uibPosition.scrollbarWidth(true) + 'px';
                    }
                    for (let el of elems) {
                        el.style.paddingRight = width;
                        el.style.paddingRight = width;
                    }
                }
            );

            $scope.$on('$destroy', function () {
                watcher();
                watcher = null;
            })
        },
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/fake-scroll.js